import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

/**
 * Get Twitch OAuth authorization URL from backend API or client fallback
 */
export const getTwitchAuthUrl = async () => {
  try {
    const response = await axios.get(`${API}/auth/login`);
    if (response.data && typeof response.data === 'object' && response.data.auth_url) {
      return response.data.auth_url;
    }
  } catch (error) {
    console.warn('[Login] /api/auth/login failed, using client fallback:', error);
  }

  const clientId = process.env.REACT_APP_TWITCH_CLIENT_ID || 'your-twitch-client-id';
  const redirectUri = `${window.location.origin}/auth/callback`;
  return `https://id.twitch.tv/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=user:read:email`;
};

/**
 * Trigger Twitch login flow
 */
export const handleTwitchLogin = async () => {
  try {
    const url = await getTwitchAuthUrl();
    console.log('[Login] Redirecting to:', url);
    window.location.href = url;
  } catch (error) {
    console.error('[Login] Error redirecting to Twitch:', error);
    alert('Could not start Twitch login. Please try again.');
  }
};
